import { IsolatedCartType, getBuyNowKey } from '@teko/cart/v2';
import { useToast } from '@teko/ds-desktop';
import { CautionOutlined } from '@teko/ds-icon';
import { logger } from '@teko/log';
import {
  AddToCartType,
  TrackAddToCartParams,
  trackAddToCart,
} from '@teko/tracking';
import { useCartV2, useProductDetailState, useTenantConfig } from 'contexts';
import { t } from 'i18n';
import { useRouter } from 'next/router';

export const useBottomButtons = () => {
  const { allowBuyNow } = useTenantConfig();

  const {
    product,
    price,
    payloadAddToCart,
    isCanAddToCard,
    stockAvailable,
    primitiveProduct,
    selectedPromotion,
  } = useProductDetailState();
  const showToast = useToast();
  const { onAddSingleItem } = useCartV2();
  const router = useRouter();

  const onAddItemToCart = async (type: AddToCartType) => {
    if (!isCanAddToCard) {
      showToast.info?.({
        title: '',
        message: t('Chỉ còn {{stockAvailable}} sản phẩm', {
          stockAvailable,
        }),
        type: 'error',
        icon: <CautionOutlined size={50} color="#E24C4B" />,
      });
      return;
    }
    if (!primitiveProduct) return;

    // params send to Teko tracking in event addToCart
    const trackAddToCartParams: TrackAddToCartParams = {
      product: {
        sku: product?.sellerSku || '',
        name: product?.name || '',
        brand: product?.brand,
        categories: product?.categories,
        price: parseFloat(
          product?.price?.supplierRetailPrice?.toString() || '0',
        ),
        addToCartPrice: price?.finalPrice || 0,
        sellerSku: product?.sellerSku,
      },
      selectedPromotionId: selectedPromotion?.promotionId,
      type,
    };

    try {
      if (!payloadAddToCart?.sku) return;

      const res = await onAddSingleItem(
        {
          sku: payloadAddToCart?.sku,
          promotionId: selectedPromotion?.promotionId,
          quantity: payloadAddToCart?.quantity,
          isPrimary: payloadAddToCart?.isPrimary,
        },
        false,
        allowBuyNow && type === AddToCartType.BUYNOW
          ? IsolatedCartType.BUY_NOW
          : undefined,
      );
      if (res) {
        trackAddToCart({
          ...trackAddToCartParams,
          status: 'success',
          cartId: res.id,
        });
      } else {
        trackAddToCart({ ...trackAddToCartParams, status: 'failed' });
      }

      if (
        res &&
        (type === AddToCartType.BUYNOW || type === AddToCartType.INSTALLMENT)
      ) {
        if (type === AddToCartType.BUYNOW && !allowBuyNow) {
          router.push('/cart');
        } else {
          const key = getBuyNowKey(true);
          router.push(`/checkout?bnk=${key}`);
        }
      }
    } catch (e) {
      trackAddToCart({ ...trackAddToCartParams, status: 'failed' });
      logger.error(e);
    }
  };

  const onBuy = (): void => {
    onAddItemToCart(AddToCartType.ADDTOCART);
  };

  const onBuyNow = () => {
    onAddItemToCart(AddToCartType.BUYNOW);
  };

  return { onBuy, onBuyNow };
};
